import { render, staticRenderFns } from "./DeliveryAddress.view.vue?vue&type=template&id=889cd95e"
import script from "./DeliveryAddress.view.vue?vue&type=script&lang=js"
export * from "./DeliveryAddress.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports